import {
  cacheExchange,
  createClient,
  dedupExchange,
  fetchExchange,
} from 'urql';
import config from '../config';

const GATEWAY_API_URL = config().gateway_api_url;

// Client for UNAUTHENTICATED pages (driver booking form, dock TV displays).
//
// Differences from the main client (./client.ts):
// - no Auth0 fetchOptionsExchange: external drivers and wall-mounted TVs have
//   no login; the booking token / dock id in the operation is the only auth.
// - no errorExchange: its 401-handling redirects to /login, which must never
//   happen on a driver's phone or a TV.
export const publicClient = createClient({
  // In MOCK mode, post to the same-origin /graphql path proxied to the mock
  // GraphQL server by the webpack dev server (see webpack.config.js). This lets
  // a tunneled device (e.g. a CT60 over ngrok) reach the backend through the
  // one tunnel, with no mixed-content or localhost-on-device problem.
  url: process.env.MOCK === 'true' ? '/graphql' : GATEWAY_API_URL,
  exchanges: [dedupExchange, cacheExchange, fetchExchange],
  fetchOptions: {
    headers: {
      'apollographql-client-name': 'com.odeko.delivery-management.web.public',
    },
  },
});
